import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import selectedItemsPanelStyles from './SelectedItemsPanel.scss';
const enhance = compose(withSelectedDeviations, withMobileContext, withTranslation());
var _React_Component;
export class SelectedItemsPanel extends (_React_Component = React.Component) {
    render() {
        const { t, selectedCount, selectionLimit, showSelectionLimit, extras, extrasClassName, isMobile } = this.props;
        if (selectedCount < 1 || selectionLimit === 1 || isMobile) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: selectedItemsPanelStyles['root']
        }, /*#__PURE__*/ React.createElement("div", {
            className: selectedItemsPanelStyles['numbers']
        }, /*#__PURE__*/ React.createElement("span", {
            className: selectedItemsPanelStyles['selected-count']
        }, t('mediapopup.selectedCount', {
            count: selectedCount
        })), showSelectionLimit && selectedCount === selectionLimit && /*#__PURE__*/ React.createElement("span", {
            className: selectedItemsPanelStyles['selected-count-of-max-count']
        }, t('mediapopup.selectedCountOfSelectionMax', {
            selectedCount,
            selectionLimit
        }))), /*#__PURE__*/ React.createElement("div", {
            className: classnames(selectedItemsPanelStyles['extras'], extrasClassName)
        }, extras));
    }
}
_define_property(SelectedItemsPanel, "defaultProps", {
    showSelectionLimit: true
});
export default enhance(SelectedItemsPanel);
